module.exports = __webpack_public_path__ + "img/delta-to-delta-3-phase-trafo.b1faee5e.svg";